import { AccordionItem } from "@szhsin/react-accordion";
import { LargePlusIcon, MinusIcon } from "assets/icons";
import cn from "classnames";
import { If } from "components";
import { Icon } from "ui";

import { FilterAccordionProps } from "./FilterAccordion.types";

import styles from "./FilterAccordion.module.scss";

const FilterAccordion = ({
  header,
  isClearDisplay,
  onClearClick,
  ...rest
}: FilterAccordionProps) => {
  const clearFilterParameter = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();

    if (onClearClick) {
      onClearClick();
    }
  };

  return (
    <AccordionItem
      {...rest}
      initialEntered
      header={({ state: { isEnter } }) => (
        <div
          className={cn(styles.header, {
            [styles.header__entered]: isEnter
          })}
        >
          <div>{header}</div>

          <div className={styles.header_rightBlock}>
            <If condition={isClearDisplay}>
              <div
                className={styles.header_clearBtn}
                onClick={(e) => clearFilterParameter(e)}
              >
                Clear
              </div>
            </If>

            <Icon
              as={isEnter ? MinusIcon : LargePlusIcon}
              boxSize={16}
              className={cn(styles.header_enteredIndicator)}
            />
          </div>
        </div>
      )}
      buttonProps={{
        className: styles.accordion_headerButton
      }}
      panelProps={{ className: styles.accordion_panel }}
    />
  );
};

export default FilterAccordion;
